module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia5_thumb-35eb5ae795d9771f73901ab65996eac1.jpg";